import * as angular from 'angular';

import { ComponentDefinition, Log } from '../../../models';

class LogsOverviewController implements angular.IComponentController {
    filteredLogs: Log[];
    selectedApplication: string;
    selectedLevel: string;
    
    readonly isLoading: boolean;
    readonly logs: Log[];

    static $inject = [];
    
    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['logs']?.currentValue) {
            this.selectedApplication = null;
            this.selectedLevel = null;
            this.filter();
        }
    }

    onCellClick(application: string, level: string) {
        this.selectedApplication = application;
        this.selectedLevel = level;
        this.filter();
    }

    private filter() {
        let filtered = this.logs;
        if (this.selectedApplication) {
            filtered = filtered.filter(l => l.application === this.selectedApplication);
        }
        if(this.selectedLevel){
            filtered = filtered.filter(l => l.level === this.selectedLevel);
        }
        this.filteredLogs = filtered;
    }
}

export const wtLogsOverview: ComponentDefinition = {
    componentId: 'wtLogsOverview',
    controller: LogsOverviewController,
    template: require('./logsOverview.component.html'),
    controllerAs: 'vm',
    bindings: {
        isLoading: '<',
        logs: '<'
    }
};
